import {Brush} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'system-design',
    children: [
      {
        path: '',
        loader: protectedLoader('ROOT', 'FULL_ACCESS'),
        async lazy() {
          const {SystemDesignPage} = await import('./pages/SystemDesignPage');
          return {element: <SystemDesignPage />};
        },
      },
    ],
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/system-design',
    text: 'System Desing',
    icon: <Brush />,
    permission: 'FULL_ACCESS',
    entitlement: 'ROOT',
  },
] as MenuItemElement[];
